import { render, staticRenderFns } from "./BillIcon.vue?vue&type=template&id=64f6b0b0&"
import script from "./BillIcon.vue?vue&type=script&lang=ts&"
export * from "./BillIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports